import { TextAreaField } from '@origin-digital/style-guide';
import React from 'react';
import analytics from '../../../../analytics';

import { isFieldTouched } from '../../../../utils/formHelpers';

import { TextAreaAdapterProps } from './TextAreaAdapter.types';

export class TextAreaAdapter extends React.Component<TextAreaAdapterProps, {}> {
  constructor(props: TextAreaAdapterProps) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const { form, field, changeHandler } = this.props;

    form.setFieldValue(field.name, event.currentTarget.value);

    if (changeHandler) {
      changeHandler({ [field.name]: event.currentTarget.value });
    }
  };

  render(): JSX.Element {
    const { field, form, label, maxLength } = this.props;

    return (
      <TextAreaField
        name={field.name}
        value={field.value}
        label={label}
        maxLength={maxLength}
        onChange={e => this.handleChange(e)}
        onBlur={field.onBlur}
        //@ts-ignore
        touched={isFieldTouched(form, field.name)}
        //@ts-ignore
        error={form.errors[field.name]}
        onClick={() => analytics.firstInteraction()}
      />
    );
  }
}

export { TextAreaAdapter as default };
